import { Copy, Typography } from "@bracket/ui";
import styled from "styled-components";
import { Avatar } from "./components/Avatar";
import { useQuery } from "@apollo/client";
import { GET_PROFILE } from "@gql/queries";
import { getAccount } from "wagmi/actions";
import { wagmiConfig } from "@wagmiconfig";

const Wrapper = styled.div`
  padding: 16px;
`;

const Container = styled.div`
  padding: 32px;
  border-radius: 8px;
  border: 1px solid var(--outline-variant);
  display: flex;
  gap: 24px;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`;

const ProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const UsernameContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const CopyButton = styled.div`
  cursor: pointer;
`;

interface AccountInfoHeaderProps {
  userData: {
    name: string;
    nickname: string;
    email: string;
  };
}

export const AccountInfoHeader: React.FC<AccountInfoHeaderProps> = ({
  userData,
}) => {
  const { name, nickname } = userData;

  const handleCopy = () => {
    navigator.clipboard.writeText(`@${nickname || "nickname"}`);
  };

  return (
    <Wrapper>
      <Container>
        {/* <Avatar /> */}
        <ProfileContainer>
          <Typography variant="h4">{name || "My full name"}</Typography>
          <UsernameContainer>
            <Typography variant="paragraphLG" color="var(--text-paragraph)">
              @{nickname || "nickname"}
            </Typography>
            <CopyButton onClick={handleCopy}>
              <Copy size={20} />
            </CopyButton>
          </UsernameContainer>
        </ProfileContainer>
      </Container>
    </Wrapper>
  );
};
